module.exports = __webpack_public_path__ + "static/media/halloween.0951cc5b.jpg";